import React, {useState, useEffect} from 'react';
import { StyledConfigurationContainer, StyledDiv, StyledLeadContainer } from '../../Components/Styled';
import { useSnackbar } from 'notistack';
import { Autocomplete, Button, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { createRequestData, getRequestDataWithoutToken } from '../../Utility/apiHelper';
import { handleValidateCodevalue, promotionalMailType } from '../../Utility/constant';
import LeadDialog from '../../Components/LeadDialog';
import BiztantuLoader from '../../Components/Loader';
import { requestHideLoader, requestShowLoader } from '../../Store/Global/action';
import ClientEmailSettings from './ClientEmailSettings';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import '../Template/template.css';

const BiztantuCampaign = () => {
    
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const [dataGridData, setDatagridData] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const dispatch = useDispatch();
    
    const [currentSelection, setCurrentSelection] = useState({
      isOpenCsvPopup: false,
    });
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedTemplate, setSelectedTemplate] = useState({
      selectedTemplate : null,
      type : "External"
    });
    const [requiredError, setRequirederror] = useState(
      {
        selectedTemplate:false,
        type : false
      }
    );


  const isLoading = useSelector(state => state?.global?.isLoading);
    useEffect(() => {
      handlegetAllNotification();
    }, []);

    const handlegetAllNotification = async() => {
      const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/get-all-notification?systemTemplateFlag=false&status=TEMPLATE_STATUS_ACTIVE&channel=TEMPLATE_CHANNEL_EMAIL`;
      const responseData = await getRequestDataWithoutToken(url);
      const {data} = responseData;
      const filterData = data?.filter(item => item?.systemTemplateFlag !== "COMMON_YES") || [];
      setDatagridData(filterData);
    };

    const handleClose = () => {
      setCurrentSelection({
        isOpenCsvPopup: false,
      });
      setSelectedFile(null);
      setSelectedTemplate({
        selectedTemplate : null,
        type : "External"
      });
      setRequirederror({
        selectedTemplate : false,
        type : false
      
      });
    };

    const handleSelectMultiRoles = (event, roles) => {
      setSelectedTemplate(prev=>({
        ...prev,
        selectedTemplate : roles
      }));
    };

    const handleOnChange = (event)=>{
      const {value,name} = event?.target
      setSelectedTemplate(prev=>({
        ...prev,
        [name] : value
      }));
    }

    const handleOpenCsvpop = () => {
      setCurrentSelection({
        isOpenCsvPopup: true,
      });
    };
  
    const handleSelectFile = (event) => {
      const file = event.target.files[0];
      setSelectedFile(file || null);
    };
      
    const handleSendExternalNotification = async() => {
      if(!selectedTemplate?.selectedTemplate || !selectedTemplate?.type) {
        enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_MSG_SELECT_REQ_FIELDS"), {variant: "warning"});
        setRequirederror({
          selectedTemplate:true,
          type : true
        });
        return;
      }
      dispatch(requestShowLoader());

      const reqbody = {
        emailSubject: selectedTemplate?.selectedTemplate?.subject,
        templateBody: selectedTemplate?.selectedTemplate?.templateBody,
        document_id: selectedTemplate?.selectedTemplate?.document_id,
        type: selectedTemplate?.type,
        templateId: selectedTemplate?.selectedTemplate?.id
      };

      const formData = new FormData();
      formData.append('data', new Blob([JSON.stringify(reqbody)], { type: 'application/json' }));
      if (selectedFile) {
        formData.append('file', selectedFile);
      }

      const url = `${process.env.REACT_APP_NODE_NOTIFICATION}/send-bulk-email`;
      const responseData = await createRequestData(formData, url, true);

      if(responseData?.status === 200) {
        enqueueSnackbar(handleValidateCodevalue(internationalise, responseData?.data), {variant: "success"});
        handleClose();
      } else {
        enqueueSnackbar(handleValidateCodevalue(internationalise, responseData?.propererror?.data?.message || 'COMMON_PLEASE_TRY_AGAIN'), {variant: 'error'});
      }

      dispatch(requestHideLoader());
    };

    return (
      <BiztantuLoader isChildren={true} open={isLoading}>
          <StyledConfigurationContainer className="campaign-header">
  <Typography variant='h6'>
    {handleValidateCodevalue(internationalise, 'NOTIFICATION_LABEL')}
  </Typography>
  
    <Button
      variant="outlined" 
      className='biztantu-sec-btn campaign-send-button'
      disabled={!specificRolePermission?.isNotificationManage}
      onClick={handleOpenCsvpop}
    >
      {handleValidateCodevalue(internationalise, "NOTI_SEND_EMAIL_DIALOG")}
    </Button>
</StyledConfigurationContainer>


          {/* Promotional Email Settings Section - below */}
              <ClientEmailSettings />
          {currentSelection?.isOpenCsvPopup && (
            <LeadDialog
              open={currentSelection?.isOpenCsvPopup}
              handleClose={handleClose}
              title={handleValidateCodevalue(internationalise, "NOTI_SEND_EMAIL_DIALOG")}
              size="lg"
              selectedowner={true}
              btnlabel={handleValidateCodevalue(internationalise, 'COMMON_SEND')}
              handleSave={handleSendExternalNotification}
            >
              <Typography className='mb-20'>
                {handleValidateCodevalue(internationalise, "NOTI_SEND_EMAIL_INST")}
              </Typography>

              <StyledLeadContainer>     
              <SelectBoxWithLabel
                  required={true}
                  name= "type"
                  error={selectedTemplate?.type ? false : requiredError?.type}
                  value= {selectedTemplate?.type || ''}
                  label={handleValidateCodevalue(internationalise,"PROMOTION_SELECT_TYPE")} 
                  optionMenuItem={promotionalMailType}
                  handleOnChange={handleOnChange}
              />
                <StyledDiv className="campaign-file-upload">
                  <input required accept='*' type="file" onChange={handleSelectFile}/>
                </StyledDiv>
                <Autocomplete
                    options={dataGridData}
                    className="campaign-template-autocomplete"
                    getOptionLabel={(option) => option?.name}
                    filterSelectedOptions={true}
                    onChange={handleSelectMultiRoles}
                    disabled={!selectedFile}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={(selectedFile && selectedTemplate?.selectedTemplate) ? false : requiredError?.selectedTemplate}
                        required
                        variant='standard'
                        value={selectedTemplate?.selectedTemplate}
                        label={handleValidateCodevalue(internationalise, 'CAMP_SELECT_TEMP')}
                        disabled={!selectedFile}
                        className="campaign-template-input"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
              </StyledLeadContainer>
            </LeadDialog>
          )}
      </BiztantuLoader>
    );
};

export default BiztantuCampaign;
